// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15bb0e3d","732":"8ba21338"}[chunkId] + ".chunk.js";
};